import { TransitionBack, TransitionCancel } from "@/features/domaine/machine-etats/types";
import { defineStore } from "pinia";
import { ref, shallowRef } from "vue";
import type { RunComponentOptions } from "./types";

export type MachineEtatStoreResult = { value: any, transitionState: any }

export const useMachineEtatStore = defineStore("MACHINE_ETAT_DISPLAY", () => {
  const visible = ref(false)

  let returnExecutionResult: ((value: MachineEtatStoreResult | PromiseLike<MachineEtatStoreResult>) => void) | null
  let throwCancel: ((value: any | PromiseLike<any>) => void) | null

  const $reset = () => {
    returnExecutionResult = null
    throwCancel = null
    visible.value = false
  }


  const setResult = (value: any, transitionState: any) => {
    returnExecutionResult?.call(null, { value, transitionState })

    returnExecutionResult = null
    throwCancel = null
  }

  const setGoBack = () => {
    throwCancel?.call(null, new TransitionBack('TRANSITION_BACK'))

    returnExecutionResult = null
    throwCancel = null
  }


  const setCancel = () => {
    throwCancel?.call(null, new TransitionCancel('TRANSITION_CANCELED'))

    returnExecutionResult = null
    throwCancel = null
  }

  const runOptions = shallowRef<RunComponentOptions>()

  const runTransaction = (options: RunComponentOptions) => {
    returnExecutionResult = null
    throwCancel = null

    return new Promise((resolve, cancel) => {
      runOptions.value = options
      visible.value = true
      returnExecutionResult = resolve
      throwCancel = cancel
    })
  }

  return { runOptions, visible, runTransaction, setResult, setCancel, setGoBack, $reset }
})
